
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buildyourdreamsetup/[locale]/closed",
      function () {
        return require("private-next-pages/buildyourdreamsetup/[locale]/closed.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buildyourdreamsetup/[locale]/closed"])
      });
    }
  